<div class="banner-container">
  <div class="banner">
    <img src="../../../assets/images/Banner_Telekom.webp" alt="Banner Bild" />
  </div>
</div>
